import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "@/store";
import en from "@/translations/en";

Vue.use(VueI18n);

const i18n = new VueI18n({
  fallbackLocale:'en',
  messages: { en }
});

const loadedLanguages: string[] = ['en'];

const i18nService = {
  setLanguage
};

if(store.getters.currentLangGet){
  setLanguage(store.getters.currentLangGet);
}


export { i18n };
export default i18nService;


function setLanguage(lang: string) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/translations/${lang}`).then(
        msgs => {
          i18n.setLocaleMessage(lang, msgs.default);
          loadedLanguages.push(lang);
          return setLanguageInternal(lang);
        }
      );
    }
    return Promise.resolve(setLanguageInternal(lang));
  }
  return Promise.resolve(lang);
}


function setLanguageInternal(lang: string) {
  i18n.locale = lang;
  store.dispatch("updateLangAc", lang);
  return lang;
}
